var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFileType = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.1667 16.9833H29.3501C25.4001 16.9833 22.1834 13.7666 22.1834 9.81659V4.99992C22.1834 4.08325 21.4334 3.33325 20.5167 3.33325H13.4501C8.31675 3.33325 4.16675 6.66659 4.16675 12.6166V27.3833C4.16675 33.3333 8.31675 36.6666 13.4501 36.6666H26.5501C31.6834 36.6666 35.8334 33.3333 35.8334 27.3833V18.6499C35.8334 17.7333 35.0834 16.9833 34.1667 16.9833Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3332 3.6834C25.6499 3.00007 24.4666 3.46674 24.4666 4.41674V10.2334C24.4666 12.6667 26.5332 14.6834 29.0499 14.6834C30.6332 14.7001 32.8332 14.7001 34.7166 14.7001C35.6666 14.7001 36.1666 13.5834 35.4999 12.9167C33.0999 10.5001 28.7999 6.15007 26.3332 3.6834Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFileType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-file-type.ab297569c579a4461f25546a45fedb80.svg";